import { filter, get, startsWith, isEqual } from "lodash"
import { createSelector } from "reselect"

const EMPTY_ARRAY = []

export const getSearchValue = state => get(state, "modules.watchlistsMenu.searchValue", null)
const getModuleSelectedWatchlists = state => get(state, "modules.watchlistsMenu.selectedWatchlists", null)
export const getWatchlists = state => get(state, "global.data.watchlists.data.watchlists", EMPTY_ARRAY)
const getWatchlistToFilter = (state, props) => get(props, "watchlistToFilter", null)
export const getSupportsRestoringDeleting = (state, props) => !!get(props, "security", null)
export const getSecurity = (state, props) => get(props, "security", null)
export const getAsOf = (state, props) => get(props, "asOf", null)
export const getModelId = (state, props) => get(props, "modelId", null)
export const getDefaultSelectedWatchlists = (state, props) => get(props, "securityWatchlists", EMPTY_ARRAY)

export const getFilteredWatchlists = createSelector(
  [getWatchlists, getSearchValue, getWatchlistToFilter],
  (watchlists, searchValue, watchlistToFilter) => {
    const filteredWatchlists = filter(watchlists, watchlist => watchlist.id !== watchlistToFilter)

    if (!searchValue) return filteredWatchlists

    return filter(filteredWatchlists, watchlist =>
      startsWith(watchlist.name.toLowerCase(), searchValue.toLowerCase()),
    )
  },
)

export const getSelectedWatchlists = createSelector(
  [getModuleSelectedWatchlists, getSupportsRestoringDeleting, getDefaultSelectedWatchlists],
  (selectedWatchlists, supportsRestoringDeleting, defaultSelectedWatchlists) => {
    if (selectedWatchlists) {
      return selectedWatchlists
    }

    if (supportsRestoringDeleting) {
      return defaultSelectedWatchlists
    }

    return EMPTY_ARRAY
  },
)

export const getApplyButtonEnabled = createSelector(
  [getModuleSelectedWatchlists, getFilteredWatchlists, getDefaultSelectedWatchlists, getSupportsRestoringDeleting],
  (selectedWatchlists, watchlists, defaultSelectedWatchlists, supportsRestoringDeleting) => {
    if (supportsRestoringDeleting) {
      // .sort() mutates in place and selectedWatchlists is a live Redux state array; sort copies
      // so the store is not mutated (RTK immutableCheck).
      return selectedWatchlists && !isEqual([...selectedWatchlists].sort(), [...defaultSelectedWatchlists].sort())
    }

    return selectedWatchlists && watchlists.length > 0 && selectedWatchlists.length > 0
  },
)
